/**
 * Converts `value` to a string if it is not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  if (typeof value == 'string') {
    return value;
  }
  return value == null ? '' : (value + '');
}

module.exports = baseToString;



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/~/lodash/internal/baseToString.js
 ** module id = 88
 ** module chunks = 0
 **/